import searchArea from './searchArea';

import './searchArea.css';

export default searchArea;
